export default __webpack_public_path__ + "static/media/user1.93ece93a.png";